import { render, staticRenderFns } from "./PosologyField.vue?vue&type=template&id=1bea37cc&scoped=true"
import script from "./PosologyField.vue?vue&type=script&lang=js"
export * from "./PosologyField.vue?vue&type=script&lang=js"
import style0 from "./PosologyField.vue?vue&type=style&index=0&id=1bea37cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea37cc",
  null
  
)

export default component.exports